import { AwsDocumentRepository as IAwsDocumentRepository } from 'repository/interfaces/aws-document-repository'
import { IApiRepository } from 'service/protocols/api/api-repository'
import { GenerateAwsPresignedUrlDocument } from 'domain/usecases/document/generate-aws-presigned-url-document'
import { UploadDocumentAws } from 'domain/usecases/document/upload-document-aws'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import { CustomError } from 'common/errors'
import { ProcessDocumentAws } from 'domain/usecases/document/process-document-aws'

export class AwsDocumentRepository implements IAwsDocumentRepository {
  constructor(private readonly apiRepository: IApiRepository) {}

  async generateAwsPresignedUrlDocument(
    params: GenerateAwsPresignedUrlDocument.Params
  ): Promise<GenerateAwsPresignedUrlDocument.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<GenerateAwsPresignedUrlDocument.Model>

    const httpResponse = await apiRepository.post({
      url: '/generate-presigned-url',
      body: params
    })

    if (
      !httpResponse.statusCode ||
      (httpResponse.statusCode && httpResponse.statusCode !== ApiStatusCode.ok)
    ) {
      throw new CustomError('Ocorreu um erro ao fazer upload do documento')
    } else {
      return httpResponse.body as GenerateAwsPresignedUrlDocument.Model
    }
  }

  async uploadDocumentAws(
    params: UploadDocumentAws.Params
  ): Promise<UploadDocumentAws.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<UploadDocumentAws.Model>

    const httpResponse = await apiRepository.put({
      headers: {
        'Content-Type': params.file_type
      },
      url: params.preSignedUrl,
      preSignedUrl: params.preSignedUrl,
      body: params.file
    })

    if (
      !httpResponse.statusCode ||
      (httpResponse.statusCode && httpResponse.statusCode !== ApiStatusCode.ok)
    ) {
      throw new CustomError('Ocorreu um erro ao fazer upload do documento')
    } else {
      return httpResponse.body as UploadDocumentAws.Model
    }
  }

  async processDocumentAws(
    params: ProcessDocumentAws.Params
  ): Promise<ProcessDocumentAws.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<ProcessDocumentAws.Model>

    const httpResponse = await apiRepository.post({
      url: '/process-document-info',
      body: params
    })

    if (
      !httpResponse.statusCode ||
      (httpResponse.statusCode && httpResponse.statusCode !== ApiStatusCode.ok)
    ) {
      throw new CustomError('Ocorreu um erro ao processar o documento')
    } else {
      return httpResponse.body as ProcessDocumentAws.Model
    }
  }
}
